import apiService from 'src/shared/config/apiService';
import { Address } from 'src/shared/types/user';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

export type UpdateSamplingPayload = {
  id: string;
  body: { address: Address };
};
type UpdateProductUpdateResponse = any;

export const updateSampling = async (
  productId: string,
  payload: UpdateSamplingPayload
): Promise<UpdateProductUpdateResponse> => {
  try {
    const { data } = await apiService.patch<UpdateProductUpdateResponse>(
      `/products/${productId}/samples/${payload.id}`,
      payload.body
    );

    return data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};
